document.addEventListener('alpine:init', () => {

  Alpine.data('mobileMenu', () => ({

		mobileMenuActive: false,

		toggleMenu() {

			this.mobileMenuActive = !this.mobileMenuActive

			if (this.mobileMenuActive) {
				this.$dispatch('mobilemenuactive')
			}

			if (!this.mobileMenuActive) {
				this.$dispatch('mobilemenunotactive')
			}
		},

		toggleSubMenu() {

			const el = this.$el

			let parentWrapper = this.$el.closest('.mobile-menu-container')
			let submenuWrapper = null

			if (el.nodeName === 'BUTTON') {
				submenuWrapper = this.$el.closest('.submenu--outer-wrapper')
			}

			if (el.nodeName === 'A') {
				submenuWrapper = this.$el.parentNode.querySelector('.submenu--outer-wrapper')
			}

			parentWrapper.style.height = 'auto'

			if (submenuWrapper.classList.contains('tw-invisible')) {
				parentWrapper.style.height = submenuWrapper.offsetHeight + 'px'
			}

			submenuWrapper.classList.toggle('tw-invisible')
		}
  }))
})
